// extracted by mini-css-extract-plugin
export default {"title":"SpecialRequestDetails_title__huo2Q","total":"SpecialRequestDetails_total__wRRwS","edit":"SpecialRequestDetails_edit__jC4TV"};